<template>
  <div class="external-kyc-root">
    <iframe :src="url" class="frame" allow="microphone; camera" />
  </div>
</template>

<script>
export default {
  props: {
    // Outside url (Mercuryo) for showing to user
    url: String,
  },

  methods: {
    receiveMessage(event) {
      if (event?.data?.type !== 'MercuryoKycResult') return
      const isKycSuccess = Boolean(event?.data?.isKycSuccess)

      if (isKycSuccess) {
        this.$emit('kyc-success')
      } else {
        this.$emit('kyc-fail')
      }
    },
  },

  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },

  beforeUnmount() {
    window.removeEventListener('message', this.receiveMessage, false)
  },
}
</script>

<style scoped lang="scss">
.frame {
  margin-top: 30px;
  width: 100%;
  height: 600px;
  border: none;
}
</style>
